import React, { useState, useEffect, useRef } from 'react'
import './Schemes.css';
import { SchemesList } from '../../components/BudgetAllocation/Schemes/SchemesList';
import { useDispatch, useSelector } from 'react-redux';
import {
    GET_SCHEME_FAIL,
} from '../../RTK/Slices/SchemeSlice';
import { get_schemes, 
    get_consolidated_schemes, 
    exportSubactivityReport,
    exportSubActivityDetailedReport
} from '../../helper/Api';
import { toast } from 'react-toastify';
import SubHeader from '../../components/Subheader/Subheader';
import CreateButton from '../../components/Tools/CreateButton';
import MainFilter from '../../components/Tools/MainFilter';
import Spinner from '../../components/Tools/spinner';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import DashboardFilter from '../Dashboard/components/DashboardFilter';
const Schemes = () => {
    const { financialYears, authData } = useSelector((state) => state.authData);
    const [key, setKey] = useState('list');
    const searchStrRef = useRef('');
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const departmentIdRef = useRef('');
    const departmentId1Ref = useRef('');
    const [schemesList, setSchemesList] = useState([]);
    const currentFY = useRef({});
    const dispatch = useDispatch();
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    })
    const [filterApplied, setFilterApplied] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
    });

    const fetchSchemes = async () => {
        try {
            setLoading(true);
            const schemes = await get_schemes({
                search_str: filterApplied.searchStr || '',
                fy_id: fyIdRef.current || '',
                department_id: filterApplied.department_id || ''
            });
            if (schemes.data.status) {
                if (schemes.data.schemes) {
                    let balance = 0;
                    currentFY.current = {
                        fy: schemes.data.current_fy,
                        total_provisional_budget: 0,
                        totalSanctionAmount: 0,
                        totalReleasedAmount: 0,
                        totalUnderApproval: 0,
                        totalPaidAmount: 0,
                        totalPendingAmount: 0,
                        totalBalanceAmount: 0,
                        totalPrevBalance: 0,
                        totalPrevPending: 0,
                    };
                    schemes.data.schemes.forEach((e) => {
                        balance += e.balance
                        currentFY.current.total_provisional_budget += e.total_provisional_budget;
                        currentFY.current.totalSanctionAmount += e.utilised_budget;
                        currentFY.current.totalReleasedAmount += e.total_budget;
                        currentFY.current.totalUnderApproval += e.pending_budget;
                        currentFY.current.totalPaidAmount += e.total_payment;
                        currentFY.current.totalPendingAmount += (e.utilised_budget - e.total_payment);
                        currentFY.current.totalBalanceAmount += e.balance;
                        currentFY.current.totalPrevBalance += e.prevYearBalance;
                        currentFY.current.totalPrevPending += e.prev_year_pending_balance;
                    });
                    setSchemesList(schemes.data.schemes);
                }
                setLoading(false);
            } else {
                setLoading(false);
                dispatch(GET_SCHEME_FAIL(schemes.data.message));
            }
        } catch (error) {
            setLoading(false);
            dispatch(GET_SCHEME_FAIL('something went wrong'));
        }

    }
    const fetchSchemesConsolidate = async () => {
        try {
            let departmentId = '';
            if (departmentIdRef.current !== "" && departmentId1Ref.current !== "") {
                // You can decide which value to send, for example, let's choose departmentIdRef.current
                departmentId = departmentId1Ref.current;
            }
            else{
                departmentId = departmentIdRef.current;
            }
            const schemes = await get_consolidated_schemes({
                department_id: departmentId || 1,
                fy_id: fyIdRef.current || '',
                search_str: searchStrRef.current || '',
            });
            if (schemes.data.status) {
                schemes.data.schemes = schemes.data.result;
                if (schemes.data.schemes) {
                    let balance = 0;
                    currentFY.current = {
                        fy: schemes.data.current_fy,
                        total_provisional_budget: 0,
                        totalSanctionAmount: 0,
                        totalReleasedAmount: 0,
                        totalUnderApproval: 0,
                        totalPaidAmount: 0,
                        totalPendingAmount: 0,
                        totalBalanceAmount: 0,
                        totalPrevBalance: 0,
                        totalPrevPending: 0,
                    };
                    schemes.data.schemes.forEach((e) => {
                        balance += e.balance
                        currentFY.current.total_provisional_budget += e.total_provisional_budget;
                        currentFY.current.totalSanctionAmount += e.utilised_budget;
                        currentFY.current.totalReleasedAmount += e.total_budget;
                        currentFY.current.totalUnderApproval += e.pending_budget;
                        currentFY.current.totalPaidAmount += e.total_payment;
                        currentFY.current.totalPendingAmount += (e.utilised_budget - e.total_payment);
                        currentFY.current.totalBalanceAmount += e.balance;
                        currentFY.current.totalPrevBalance += e.prevYearBalance;
                        currentFY.current.totalPrevPending += e.prev_year_pending_balance;
                    });
                    setSchemesList(schemes.data.schemes);
                }
            } else {
                dispatch(GET_SCHEME_FAIL(schemes.data.message));
            }
        } catch (error) {
            dispatch(GET_SCHEME_FAIL('something went wrong'));
        }

    }
    useEffect(() => {
        fetchSchemes();
    }, [fyIdRef.current, filterApplied]);

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const bootList = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    }
    const downloadFile = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.xlsx"); // Suggested filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };


    const handleSubactivityDetailedReportExport = async () => {
        try {
            setLoading(true);
            const response = await exportSubActivityDetailedReport(authData.user.department_details.id);
            if (response.data.status) {
                downloadFile(response.data.url);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error(response.data.error, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong!', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const handleSubactivityReportExport = async (department_level) => {
        try {
            setLoading(true);
            const response = await exportSubactivityReport({
                fy_id: fyIdRef.current,
                department_level: department_level,
            });
            if (response.data.status) {
                downloadFile(response.data.url);
                setLoading(false);
            } else {
                setLoading(false);
                toast.error(response.data.error, {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            setLoading(false);
            toast.error('Something went wrong!', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    // filter setup or states
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        const newPayload = {
        ...filterPayload,
        [name]: "",
        };
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    }

    return (
        <div className=''>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Schemes</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Schemes"/>
                </div>
                <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        <button type="button" className="navigation_button" onClick={() => handleSubactivityReportExport(filterApplied.tier || authData.user.department_level)}>
                            <span className="fs-14px">Export Child Departments SubActivity Report</span>
                        </button>

                        <button type="button" className="navigation_button" onClick={() => handleSubactivityDetailedReportExport()}>
                            <span className="fs-14px">Export Subactivity Report</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='scheme p-3'>
                <div className='scheme p-2'>
                    <DashboardFilter 
                        openFilterModal={setOpen} 
                        filterPayload={filterApplied} 
                        handleFilterRemove={handleFilterRemove}
                        isTierRemovalRequired={true}
                    />
                    <div className='all_tabs'>
                        <SchemesList listType={key} schemesList={schemesList} financialYearStats={currentFY.current} setLoading={setLoading} department_id={filterApplied.department_id} fetchSchemes={fetchSchemes} setSchemesList={setSchemesList}/>
                    </div>
                </div>
            </div>
            { authData.user.user_type === 'l1' && <CreateButton title={"Add Scheme"} url={"/add-scheme"}/> }
            
            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen} 
                handleFilterClick={bootList} 
                filterPayload={filterPayload}
                setConsolidate={setFilterPayload}
                type="Schemes"/>
        </div>
    )
}

export default Schemes;
